module.exports = __webpack_public_path__ + "img/sh_18.5c665f63.jpg";